/**
 * @module plantChanged
 *
 * B102: a tiny signal that says "the gardener herself just changed this plant" (a stage, a photo, an
 * edit). The Plants page reads it to keep that plant where it was drawn (features/plant-list/lib/keepInPlace).
 * Only her own saves fire it (PlantsContext.updateSinglePlant, the one call every save path makes);
 * a refetch, another tab or a server change never does. It is UI state only and decides nothing.
 */

/** Plant ids the gardener changed that the Plants page has not yet read. */
const changed = new Set<number>();

/**
 * Says the gardener just changed this plant. Call before the new plant is written into the list, so the
 * page can still see where the plant was drawn.
 *
 * @param plantObjId - The plant's id.
 */
export function markPlantChanged(plantObjId: number | string): void {
  changed.add(Number(plantObjId));
}

/**
 * Hands over, and forgets, the plants changed since the last call.
 *
 * @returns The ids of the changed plants.
 */
export function takeChangedPlants(): number[] {
  const ids = [...changed];
  changed.clear();
  return ids;
}
